export default __webpack_public_path__ + "static/media/content_tab04_1_01.f7c6d66d.png";